/* ============================================================
   HIT Energy — native Shopify cart

   1) Injects a gold "Shop Now" button into the top-right header,
      alongside the native cart icon.
   2) Appends the Bourvic Studio signature to the footer, site-wide.

   ------------------------------------------------------------
   ARCHITECTURE NOTE (2026-08-31)

   This file used to derive the homepage buy buttons from external
   retailer links: it queried the DOM for those links and inserted an
   "Add to Cart" beside each one. The buy path therefore existed only
   as a side effect of an external link being present — remove the
   links and the homepage lost every buy button.

   That coupling is gone. The hero, mission and trust-block buy
   buttons are now REAL LINKS written directly into
   templates/index.json and depend on this script for nothing.

   Keep it that way: a store's buy path should never be a side
   effect of third-party markup. Restoration details live in the
   project runbook, not here.
   ============================================================ */
(function () {
  var PRODUCT_URL = "/products/hit-energy-shot";
  var BOURVIC_URL = "https://bourvicstudio.com";
  var BOURVIC_LOGO = "https://cdn.shopify.com/s/files/1/0968/6581/2553/files/bourvic-monogram-gold.webp?v=1787266700&width=60";

  /* ---- Top-right "Shop Now" button (sits next to the cart icon) ---- */
  function injectHeaderCta() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.hit-shop-now')) return;
    var a = document.createElement('a');
    a.className = 'button hit-shop-now hit-atc-btn hit-atc-btn--header';
    a.href = PRODUCT_URL;
    // "Now" is hidden under 750px: at 320px the full label collides with the
    // centred logo. See injectHeaderCtaStyles() below.
    a.innerHTML = 'Shop<span class="hit-shop-now__full"> Now</span>';
    a.setAttribute('style', 'padding:10px 20px;border-radius:12px;font-weight:700;text-decoration:none;white-space:nowrap;display:inline-flex;align-items:center;margin-right:12px;');
    actions.insertBefore(a, actions.firstChild);
  }

  /* ---- Header CTA responsive rules ----
     Scoped to .hit-shop-now on purpose. These live here rather than in
     hit-custom.css because broad selectors in that file have collided with
     third-party markup three times (see the runbook incident log). */
  function injectHeaderCtaStyles() {
    if (document.getElementById('hit-shop-now-css')) return;
    var s = document.createElement('style');
    s.id = 'hit-shop-now-css';
    s.textContent =
      '@media (max-width:749px){' +
      '.hit-shop-now__full{display:none;}' +
      '.hit-shop-now{padding:8px 14px !important;font-size:0.85rem !important;margin-right:8px !important;}' +
      '}';
    document.head.appendChild(s);
  }

  /* ---- Bourvic Studio signature (site-wide footer) ---- */
  function injectSignature() {
    if (document.querySelector('.bourvic-sig')) return;
    var host = document.querySelector('.footer') || document.querySelector('footer') || document.querySelector('[class*="footer"]') || document.body;
    var d = document.createElement('div');
    d.className = 'bourvic-sig';
    d.innerHTML = "<a href='" + BOURVIC_URL + "' target='_blank' rel='noopener'><img class='bourvic-sig__logo' src='" + BOURVIC_LOGO + "' alt='Bourvic Studio' width='30' height='21' loading='lazy'><span class='bourvic-sig__name'>Bourvic Studio</span><span class='bourvic-sig__sep'>&middot;</span><span class='bourvic-sig__year'>MMXXVI</span></a>";
    host.appendChild(d);
  }

  /* ============================================================
     21+ age verification gate.

     BUILT BUT DISABLED. The card processor asked for a 21+ gate;
     HIT has argued back that paraxanthine is caffeine-equivalent and
     should not need one. The processor accepted the 18+ position on 2026-09-03 and no
     longer requires a gate, so this stays off. AGE_GATE_MIN_AGE is set
     to 18 to match every other age statement on the site.

     Styles are inline on purpose: a compliance gate must not depend
     on an external stylesheet loading.
     ============================================================ */
  var AGE_GATE_ENABLED = false;
  var AGE_GATE_MIN_AGE = 18;
  var AGE_GATE_KEY = 'hit-age-ok';

  function ageGate() {
    if (!AGE_GATE_ENABLED) return;
    try { if (localStorage.getItem(AGE_GATE_KEY) === '1') return; } catch (e) {}
    if (document.getElementById('hit-age-gate')) return;

    var ov = document.createElement('div');
    ov.id = 'hit-age-gate';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Age verification');
    ov.setAttribute('style', 'position:fixed;inset:0;z-index:99999;background:rgba(5,5,5,0.97);display:flex;align-items:center;justify-content:center;padding:24px;');

    var card = document.createElement('div');
    card.setAttribute('style', 'max-width:460px;width:100%;text-align:center;border:1px solid rgba(255,199,0,0.35);border-radius:18px;padding:36px 30px;background:#0a0a0a;color:#fff;font-family:Inter,system-ui,sans-serif;');
    card.innerHTML =
      "<h2 style='margin:0 0 10px;font-family:Archivo,sans-serif;font-size:1.5rem;'>Are you " + AGE_GATE_MIN_AGE + " or older?</h2>" +
      "<p style='margin:0 0 22px;opacity:.8;font-size:.92rem;line-height:1.5;'>You must be " + AGE_GATE_MIN_AGE +
      " years or older to purchase from this website. This product is not intended for children, or pregnant or lactating women.</p>";

    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = "Yes, I am " + AGE_GATE_MIN_AGE + " or older";
    yes.setAttribute('style', 'display:block;width:100%;margin:0 0 10px;padding:14px 22px;border:none;border-radius:14px;background:#ffc700;color:#0a0a0a;font-weight:700;font-size:1rem;cursor:pointer;font-family:inherit;');

    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = 'No';
    no.setAttribute('style', 'display:block;width:100%;padding:14px 22px;border:1px solid rgba(255,255,255,0.28);border-radius:14px;background:transparent;color:#fff;font-weight:700;font-size:1rem;cursor:pointer;font-family:inherit;');

    yes.addEventListener('click', function () {
      try { localStorage.setItem(AGE_GATE_KEY, '1'); } catch (e) {}
      ov.remove();
      document.documentElement.style.overflow = '';
    });
    no.addEventListener('click', function () {
      card.innerHTML = "<h2 style='margin:0 0 10px;font-family:Archivo,sans-serif;font-size:1.4rem;'>Sorry</h2>" +
        "<p style='margin:0;opacity:.8;font-size:.92rem;line-height:1.5;'>You must be " + AGE_GATE_MIN_AGE +
        " years or older to purchase from this website.</p>";
    });

    card.appendChild(yes);
    card.appendChild(no);
    ov.appendChild(card);
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(ov);
    yes.focus();
  }

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(ageGate);
  ready(injectHeaderCtaStyles);
  ready(injectHeaderCta);
  ready(injectSignature);

  /* The header re-renders on cart updates and section reloads — re-inject.
     Debounced: an undebounced observer re-runs on every DOM mutation and
     reintroduces the mobile jank fixed in 2026-08. */
  var hg = document.getElementById('header-group');
  if (hg && window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = null; injectHeaderCta(); });
    }).observe(hg, { childList: true, subtree: true });
  }
  document.addEventListener('cart:update', injectHeaderCta);
})();


/* ------------------------------------------------------------------------------------------
 * Free Samples giveaway -> Klaviyo hand-off (added 2026-09-11)
 * Runs only where form.hit-gwf exists (/pages/giveaway). Sends the entry to Klaviyo, then
 * submits the form to web3forms exactly as before, so Dustin's notification email is unchanged.
 * - every entrant: Klaviyo profile + "Submitted Giveaway Entry" event
 * - only entrants who tick "Marketing Opt In": subscribed to the "Email" list (QQrBsD)
 * - city + state ARE sent as Klaviyo location (Official Rule 8 reworded 2026-09-11);
 *   street address, apt and ZIP are NOT sent
 * - fail-safe: web3forms submission always happens, at most 3 s after the click
 * ---------------------------------------------------------------------------------------- */
(function () {
  var LIST_ID = 'QQrBsD', CO = 'XnL6R3', REV = '2024-10-15';
  function init() {
    var f = document.querySelector('form.hit-gwf');
    if (!f || f.dataset.klv) return;
    f.dataset.klv = '1';
    function v(n) { var e = f.elements[n]; if (!e) return ''; if (e.type === 'checkbox') return e.checked; return (e.value || '').trim(); }
    function post(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CO, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'revision': REV },
        body: JSON.stringify(body)
      });
    }
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (f.dataset.sending) return;
      f.dataset.sending = '1';
      var btn = f.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      var done = false;
      function finish() { if (done) return; done = true; HTMLFormElement.prototype.submit.call(f); }
      try {
        if (v('botcheck') === true) { finish(); return; }
        var email = v('email'), optin = v('Marketing Opt In') === true, fn = v('First Name'), ln = v('Last Name');
        var loc = { city: v('City'), region: v('State'), country: 'United States' };
        var props = {
          'Giveaway Entrant': true, 'Giveaway Entry Date': new Date().toISOString(), 'Giveaway Marketing Opt In': optin,
          'Age Range': v('Age Range'), 'Occupation': v('Occupation'), 'Current Energy Source': v('Current Energy Source'),
          'Tried HIT': v('Tried HIT'), 'Social Handle': v('Social Handle'), 'Requested Retailer': v('Requested Retailer')
        };

        /* Shipping fields for the $0 sample order (added 2026-10-05).
           These go on the EVENT only, never on the profile: the street address belongs to this one entry,
           not to a permanent marketing record. That keeps Official Rule 8 true ("your street address is
           used only to ship prizes") while still letting a Klaviyo flow build the Shopify order.
           Keys are lowercase with no spaces on purpose, so the webhook can read them as
           {{ event.ship_address1 }} instead of fighting Klaviyo's lookup syntax for "Ship Address 1".
           Sanitised because the webhook interpolates them straight into a JSON body: one stray double
           quote or backslash in an address would otherwise break the whole request. The State select has
           no value attributes, so .value returns its text, which is already a 2-letter code (e.g. MO) --
           exactly what Shopify's provinceCode wants. */
        function ship(n, max) {
          return String(v(n) || '')
            .replace(/[\\"\u0000-\u001f\u007f]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, max);
        }
        var shipProps = {
          ship_first_name: ship('First Name', 60),
          ship_last_name: ship('Last Name', 60),
          ship_email: ship('email', 120),
          ship_address1: ship('Address', 120),
          ship_address2: ship('Address 2', 120),
          ship_city: ship('City', 60),
          ship_state: ship('State', 2),
          ship_zip: ship('ZIP', 10),
          ship_country_code: 'US'
        };
        var evProps = {
          'Occupation': props['Occupation'], 'Current Energy Source': props['Current Energy Source'],
          'Tried HIT': props['Tried HIT'], 'Marketing Opt In': optin
        };
        for (var sk in shipProps) {
          if (Object.prototype.hasOwnProperty.call(shipProps, sk)) evProps[sk] = shipProps[sk];
        }
        var jobs = [
          post('profiles', { data: { type: 'profile', attributes: { email: email, first_name: fn, last_name: ln, location: loc, properties: props } } }),
          post('events', { data: { type: 'event', attributes: {
            properties: evProps,
            metric: { data: { type: 'metric', attributes: { name: 'Submitted Giveaway Entry' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } } } } })
        ];
        if (optin) {
          jobs.push(post('subscriptions', { data: { type: 'subscription',
            attributes: { custom_source: 'Free Samples giveaway form', profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } } } }));
        }
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email, first_name: fn, last_name: ln }); } catch (e) {}
        Promise.allSettled(jobs).then(finish, finish);
        setTimeout(finish, 3000);
      } catch (e) { finish(); }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ----------------------------------------------------------------------------------------------
 * Cart free-shipping progress bar (added 2026-09-11)
 * Shows how far the cart is from free shipping, in the cart drawer and on /cart, directly above
 * the estimated total. FREE_SHIP_CENTS must match the Standard shipping rate condition (runbook §11).
 * Horizon re-renders cart sections by morphing, which drops injected nodes, so a debounced observer
 * puts the bar back, and every cart:update refetches /cart.js for the current total.
 * Nothing is fetched while the cart is empty (no .cart__total-container on the page).
 * Debounced with setTimeout, not requestAnimationFrame: a rAF queued before the page first paints can
 * be dropped, which left `pending` stuck and the bar missing in draft testing (2026-09-11).
 * ---------------------------------------------------------------------------------------------- */
(function () {
  var FREE_SHIP_CENTS = 5000;
  var total = null, loading = false, pending = 0, gen = 0, failed = 0;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function css() {
    if (document.getElementById('hit-ship-bar-css')) return;
    var s = document.createElement('style');
    s.id = 'hit-ship-bar-css';
    s.textContent =
      '.hit-ship-bar{margin:0 0 14px;font-size:.875rem;line-height:1.4;text-align:left;}' +
      '.hit-ship-bar__text{margin:0 0 8px;font-weight:600;}' +
      '.hit-ship-bar__track{height:8px;border-radius:999px;background:rgba(127,127,127,.28);overflow:hidden;}' +
      '.hit-ship-bar__fill{height:100%;width:0;border-radius:999px;background:#ffc700;transition:width .35s ease;}';
    document.head.appendChild(s);
  }

  function refresh() {
    if (loading) return;
    loading = true;
    var g = gen, root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { failed = 0; if (g === gen) total = c.total_price; })
      .catch(function () { failed++; })
      .then(function () { loading = false; if (failed < 3) schedule(); });
  }

  function render(bar) {
    if (bar.getAttribute('data-total') === String(total)) return;
    bar.setAttribute('data-total', String(total));
    var left = FREE_SHIP_CENTS - total;
    var pct = Math.max(0, Math.min(100, Math.round(total / FREE_SHIP_CENTS * 100)));
    bar.querySelector('.hit-ship-bar__text').textContent =
      left > 0 ? 'Add ' + money(left) + ' more for free shipping' : 'Your order ships free';
    bar.querySelector('.hit-ship-bar__fill').style.width = pct + '%';
    bar.querySelector('.hit-ship-bar__track').setAttribute('aria-valuenow', String(pct));
  }

  function ensure() {
    pending = 0;
    var anchors = document.querySelectorAll('.cart__total-container');
    if (!anchors.length) return;
    if (total === null) { refresh(); return; }
    for (var i = 0; i < anchors.length; i++) {
      var anchor = anchors[i], prev = anchor.previousElementSibling;
      var bar = prev && prev.classList.contains('hit-ship-bar') ? prev : null;
      if (total <= 0) { if (bar) bar.remove(); continue; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'hit-ship-bar';
        bar.innerHTML = '<p class="hit-ship-bar__text"></p>' +
          '<div class="hit-ship-bar__track" role="progressbar" aria-label="Progress to free shipping" ' +
          'aria-valuemin="0" aria-valuemax="100"><div class="hit-ship-bar__fill"></div></div>';
        anchor.parentNode.insertBefore(bar, anchor);
      }
      render(bar);
    }
  }

  function schedule() { if (!pending) pending = setTimeout(ensure, 60); }

  function init() {
    css();
    schedule();
    document.addEventListener('cart:update', function () { gen++; total = null; schedule(); });
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ----------------------------------------------------------------------------------------------
 * Walmart.com square (added 2026-09-29, replaces the side pop-in of 2026-09-14)
 * Dustin asked for Walmart off the site apart from ONE small square at the bottom of the home page.
 * So: homepage only, static (no timer, no dismiss, nothing fixed to the viewport), placed as the last
 * thing in <main> so it sits under the mailing-list section and above the footer. It cannot overlap the
 * buy buttons or the sticky add-to-cart bar, which is what the old pop-in kept having to dodge.
 * The listing URL is hardcoded here and nowhere else on the site. Removing this block removes Walmart
 * from the storefront entirely. Wording follows the language rule: "on Walmart.com".
 * ---------------------------------------------------------------------------------------------- */
(function () {
  var WALMART_URL = 'https://www.walmart.com/ip/HIT-Energy-Shot-Caffeine-Free-Paraxanthine-225mg-Sugar-Free-Strawberry-Focus-and-Energy-Supplement-with-B12-2-fl-oz-6-Pack/20781169726';

  function css() {
    if (document.getElementById('hit-wm-square-css')) return;
    var s = document.createElement('style');
    s.id = 'hit-wm-square-css';
    s.textContent =
      '.hit-wm-square-wrap{display:flex;justify-content:center;padding:8px 20px 44px;}' +
      '.hit-wm-square{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;' +
        'width:168px;height:168px;box-sizing:border-box;padding:16px 12px;background:#141414;color:#fff;' +
        'border:1px solid rgba(255,199,0,.45);border-radius:14px;text-decoration:none;' +
        'transition:border-color .2s ease,background .2s ease,transform .15s ease;}' +
      '.hit-wm-square:hover,.hit-wm-square:focus-visible{border-color:#ffc700;background:#181818;transform:translateY(-2px);text-decoration:none;}' +
      '.hit-wm-square__eyebrow{font-size:.62rem;letter-spacing:.18em;text-transform:uppercase;color:#ffc700;font-weight:700;}' +
      '.hit-wm-square__name{margin-top:8px;font-size:1.02rem;font-weight:700;line-height:1.2;color:#fff;}' +
      '.hit-wm-square__sub{margin-top:6px;font-size:.72rem;opacity:.7;}' +
      '.hit-wm-square__cta{margin-top:10px;font-size:.72rem;font-weight:700;color:#ffc700;}' +
      '@media (max-width:749px){.hit-wm-square{width:150px;height:150px;}.hit-wm-square-wrap{padding-bottom:36px;}}' +
      '@media (prefers-reduced-motion:reduce){.hit-wm-square{transition:none;}}';
    document.head.appendChild(s);
  }

  function build() {
    if (location.pathname !== '/') return;
    if (document.getElementById('hit-wm-square')) return;
    var host = document.querySelector('main') || document.body;
    css();
    var wrap = document.createElement('div');
    wrap.id = 'hit-wm-square';
    wrap.className = 'hit-wm-square-wrap';
    wrap.innerHTML =
      '<a class="hit-wm-square" href="' + WALMART_URL + '" target="_blank" rel="noopener">' +
        '<span class="hit-wm-square__eyebrow">Also on</span>' +
        '<span class="hit-wm-square__name">Walmart.com</span>' +
        '<span class="hit-wm-square__sub">HIT Energy 6 Pack</span>' +
        '<span class="hit-wm-square__cta">Shop &rarr;</span>' +
        '<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;"> (opens in a new tab)</span>' +
      '</a>';
    host.appendChild(wrap);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();


/* ----------------------------------------------------------------------------------------------
 * Cart drawer opens itself on add to cart (added 2026-10-02)
 * Horizon already does this natively. assets/cart-drawer.js carries
 *   #handleCartAdd = () => { this.hasAttribute('auto-open') && this.showDialog() }
 * and snippets/header-actions.liquid prints that attribute when settings.auto_open_cart_drawer is
 * on. So all this block does is put the attribute on the element and let Horizon's own handler run.
 * No add-to-cart listener of our own: nothing to double-fire, nothing to keep in sync with the theme.
 *
 * Why not just set the theme setting? That setting lives in config/settings_data.json, the same file
 * that carries the Klaviyo and Judge.me app embeds. Rewriting it on a draft is exactly the shape of
 * incident #13 (an embed silently rolled back by a publish). Leaving that file byte-identical to MAIN
 * means anything Dustin toggles in Themes -> Customize before publishing survives.
 * If the real setting is ever switched on, this becomes a no-op -- hasAttribute() short-circuits.
 * ---------------------------------------------------------------------------------------------- */
(function () {
  function mark() {
    var list = document.querySelectorAll('cart-drawer-component');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].hasAttribute('auto-open')) list[i].setAttribute('auto-open', '');
    }
  }

  function start() {
    mark();
    // Horizon re-renders cart sections by morphing, so the component can be replaced with a fresh
    // element that has lost the attribute. Re-mark on cart:update and on DOM changes, debounced with
    // setTimeout rather than rAF for the reason in the ship-bar block above.
    var pending = null;
    function soon() {
      if (pending) clearTimeout(pending);
      pending = setTimeout(function () { pending = null; mark(); }, 60);
    }
    document.addEventListener('cart:update', soon);
    if (window.MutationObserver && document.body) {
      new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
